/* globals window, $ */
'use strict';

$(function () {
  //Window update
  var currentProgress = 0;
  $(window).resize(function () {
    layout(currentProgress);
  });

  $('.member-link').on('click', function (event) {
    var isMobile = $('#nav-bar').css('display') === 'none';
    if (isMobile) {
      return;
    }
    event.preventDefault();
  });

  //Show
  function showTeamOverlay(startIndex) {
    return; //disable for now...
    var isMobile = $('#nav-bar').css('display') === 'none';
    if (isMobile) {
      return;
    }
    $('#team-overlay').addClass('show');
    $('#team-overlay').removeClass('hidden');
    layout(startIndex);
  }

  $('.team-agent').on('click', function (event) {
    //Wow..
    $('.team-agent').each(function (index) {
      if (event.currentTarget === $(this).get(0)) {
        showTeamOverlay(index);
      }
    });
  });

  //Hide
  function hideTeamOverlay() {
    $('#team-overlay').removeClass('show');
    $('#team-overlay').addClass('hidden');
  }

  $('.team-overlay-background').on('click', function () {
    hideTeamOverlay(true);
  });

  $('.icon-close').on('click', function () {
    hideTeamOverlay(true);
  });

  $(document).keyup(function (e) {
    if (e.keyCode === 27) {
      //27 = ESC
      hideTeamOverlay();
    }
  });

  //Next/Previous
  $('.member-container').on('click', function () {
    if ($(this).css('opacity') >= 1.0) {
      return;
    }
    if ($(this).position().left < 0) {
      previous();
    } else {
      next();
    }
  });

  function next() {
    var previousProgress = currentProgress;
    startTimer(300, function (progress) {
      progress = progress * (2.0 - progress);
      layout(progress + previousProgress);
    });
  }

  function previous() {
    var previousProgress = currentProgress;
    startTimer(300, function (progress) {
      progress = progress * (2.0 - progress);
      layout(-progress + previousProgress);
    });
  }

  //Animation
  function layout(progress) {
    currentProgress = progress;

    var windowWidth = $(window).width();
    var windowHeight = $(window).height();

    $('.member-container').each(function (index) {
      var divWidth = $(this).width();
      var divHeight = $(this).height();
      var divProgress = index - progress;
      var offset = divProgress * (divWidth + (windowWidth / divWidth) * 50);
      var centeredLeft = (windowWidth - divWidth) / 2;
      var centeredTop = (windowHeight - divHeight) / 2;
      var opacity = Math.min(1, Math.abs(divProgress / 2));

      $(this).css({
        top: centeredTop,
        left: centeredLeft + offset,
        opacity: 1 - opacity,
      });
    });
  }
});

function startTimer(duration, update) {
  var tick = 0;
  var tickLength = 1000 / 60;
  var timer = setInterval(function () {
    if (tickLength * tick > duration) {
      clearInterval(timer);
      update(1);
    } else {
      var progress = (tickLength * tick) / duration;
      update(progress);
    }
    tick += 1;
  }, tickLength);
}
